'use client';

/* eslint-disable react/no-danger */
import React from 'react';
import Script from 'next/script';
type FacebookSDKProps = {
  facebookAppId: string;
};
export const FacebookSDKScript = ({
  facebookAppId
}: FacebookSDKProps) => <Script id="facebook-sdk-script" dangerouslySetInnerHTML={{
  __html: `window.fbAsyncInit = function() {
        FB.init({
          appId: ${facebookAppId},
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v11.0'
        });
      };`
}} data-sentry-element="Script" data-sentry-component="FacebookSDKScript" data-sentry-source-file="index.tsx" />;